<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "SUBMIT_STATIC_TEXT1" | globalTranslate }}
    </h1>

    <hr />
    @if (!bccExt && !isIME) {
    <p class="static-text">
      <span>{{ "SUBMIT_STATIC_TEXT2" | globalTranslate }}</span>
      <span> {{ keyword | globalTranslate }} </span>
      <span>{{ "SUBMIT_STATIC_TEXT3" | globalTranslate }}</span>
      <span>{{ "SUBMIT_STATIC_TEXT3_01" | globalTranslate }}</span>
      <span>1-855-259-0701 </span>
      <span>{{ "SUBMIT_STATIC_TEXT3_02" | globalTranslate }}</span>
      <span>P.O. Box 305240, Nashville, TN 37230-5240. </span>
      <span>{{ "SUBMIT_STATIC_TEXT3_03" | globalTranslate }}</span>
      <span>1-855-315-0669. </span>
      <span>{{ "SUBMIT_STATIC_TEXT3_04" | globalTranslate }}</span>
    </p>
    } @if (bccExt || isIME) {
    <p>
      I know that I must tell TennCare if anything changes (and is different
      than) what I answered on this {{ keyword }} Form within 10 days. I can
      report changes online at www.tenncareconnect.tn.gov. I can call
      1-855-259-0701 to report any changes. I can mail changes to TennCare
      Connect at P.O. Box 305240, Nashville, TN 37230-5240. I can fax changes to
      1-855-315-0669. Someone at a county DHS office can help me report a
      change. I understand that a change in my information could affect the
      eligibility for a member(s) of my household.
    </p>
    }

    <p class="static-text">{{ "SUBMIT_STATIC_TEXT4" | globalTranslate }}</p>
    @if (!bccExt && !isIME) {
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT5" | globalTranslate }}</p>
    } @if (bccExt || isIME) {
    <p class="static-text">
      I know that if I am approved, I can’t keep any health insurance or medical
      payments I get from insurance or other companies. Those payments belong to
      the State. I understand I must sign them over to the State.
    </p>
    }
    <p>{{ "SUBMIT_STATIC_TEXT9" | globalTranslate }}</p>
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT7" | globalTranslate }}{{ keyword3 }},
      {{ "SUBMIT_STATIC_TEXT8" | globalTranslate }}
    </p>
    @if (!bccExt && !isIME) {
    <p [innerHTML]="'SUBMIT_STATIC_TEXT10' | globalTranslate"></p>
    } @if (bccExt || isIME) {
    <p>
      I know if the State pays for medical bills or for nursing home care for
      me, the State may get that money back.  I know that after my death, the
      State may be paid back with money from my estate.
    </p>
    }
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT11" | globalTranslate }}</p>
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT12" | globalTranslate }}</p>
    @if (translatedLang === 'en' && !bccExt && !isIME && !isPreterm) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT13" | globalTranslate }}
      <span> {{ keyword | globalTranslate }} </span>
      {{ "SUBMIT_STATIC_TEXT14" | globalTranslate }}
    </p>
    } @if (bccExt || isIME) {
    <p>
      If anyone on the application is eligible for health care coverage with
      TennCare, I am giving TennCare rights to pursue and get any money from
      other health insurance, legal settlements, or other third parties. I am
      also giving TennCare rights to pursue and get medical support from a
      spouse or parent.
    </p>
    } @if (translatedLang !== 'en' && !bccExt && !isIME && !isPreterm) {
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT13" | translate }}</p>
    } @if (isPreterm) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT13_QFR" | globalTranslate }}
    </p>
    } @if (!bccExt && !isIME && !isPreterm) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT15_1" | globalTranslate }}
      <span> {{ keyword | globalTranslate }} </span>
      {{ "SUBMIT_STATIC_TEXT15_2" | globalTranslate }}
    </p>
    } @if (isPreterm) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT15_QFR" | globalTranslate }}
    </p>
    } @if (bccExt || isIME) {
    <p>
      Does any child on this application have a parent living outside of the
      home? If yes, I know I will be asked to cooperate with the agency that
      collects medical support from an absent parent. If I think that
      cooperating to collect medical support will harm me or my children, I can
      tell TennCare and I may not have to cooperate.
    </p>
    }
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT16" | globalTranslate }}</p>
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT17" | globalTranslate }}</p>

    <p class="static-text">{{ "SUBMIT_STATIC_TEXT45" | globalTranslate }}</p>

    <h2 class="section-header">
      {{ "SUBMIT_STATIC_TEXT18" | globalTranslate }}
    </h2>

    <hr />
    @if (!isIME) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT19" | globalTranslate }}&nbsp;
      <span [innerHTML]="'SUBMIT_STATIC_TEXT20' | globalTranslate">{{
        "SUBMIT_STATIC_TEXT20" | globalTranslate
      }}</span>
      {{ "SUBMIT_STATIC_TEXT22" | globalTranslate }}
    </p>
    } @if (isIME) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT19_1" | globalTranslate }}&nbsp;
      <span [innerHTML]="'SUBMIT_STATIC_TEXT20_1' | globalTranslate"></span
      >{{ "SUBMIT_STATIC_TEXT20_1" | globalTranslate }}
      {{ "SUBMIT_STATIC_TEXT21" | globalTranslate }}
      {{ "SUBMIT_STATIC_TEXT22" | globalTranslate }}
    </p>
    }
    <h2 class="section-header">
      {{ "SUBMIT_STATIC_TEXT23" | globalTranslate }}
    </h2>

    <hr />
    @if (!bccExt && !isIME) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT24" | globalTranslate }}
      {{ "SUBMIT_STATIC_TEXT25" | globalTranslate }}
      <a
        class="link_text_wrap"
        href="https://www.tn.gov/tenncare/members-applicants/civil-rights-compliance.html"
      >
        <strong>
          https://www.tn.gov/tenncare/members-applicants/civil-rights-compliance
        </strong></a
      >
      {{ "SUBMIT_STATIC_TEXT26" | globalTranslate }}
    </p>
    } @if (bccExt || isIME) {
    <p>
      We do not allow unfair treatment in our program. No one is treated in a
      different way because of race, color, birthplace, religion, language, sex,
      age, or disability. Do you think you’ve been treated unfairly? Do you have
      more questions? Do you need more help? You can make a free call to
      TennCare Connect at 855-259-0701. Or go to
      <a
        class="view-tennCare-title link_text_wrap"
        href="https://www.tn.gov/tenncare/members-applicants/civil-rights-compliance.html"
        ><strong
          >http://www.tn.gov/tenncare/topic/non-discrimination-compliance</strong
        >
      </a>
      to learn more.
    </p>
    } @if (isPresumptive && !isFinReassessment) {
    <div>
      <h2 class="section-header">Presumptive Applications</h2>
      <hr />
      <p class="static-text">
        I want to apply for temporary TennCare based on TennCare's rules. I
        understand that TennCare is using the facts on this page to decide if I
        can get TennCare. I know that if I lie on purpose to get TennCare, I
        could be fined or go to jail. I know if I do not submit a full
        Application now, I must also mail or apply for TennCare at
        Tenncareconnect.tn.gov by the end of next month or I will lose coverage.
        If I am not eligible, I know I can still apply for TennCare and other
        programs at
        <a href="http://www.tenncareconnect.tn.gov">Tenncareconnect.tn.gov</a>.
      </p>
      <nh-checkbox
        name="presumptiveApplicationSignedBySw"
        [control]="getControl('data.presumptiveApplicationSignedBySw')"
        checkedValue="PARTNER_PORTAL"
        [mandatory]="true"
        label="By checking this box, I agree that this information is true and correct based on what I know."
        class="label-section"
      >
      </nh-checkbox>
      <nh-alert
        type="danger"
        [isOpen]="
          this.isShowSign &&
          !this.getValue('data.presumptiveApplicationSignedBySw')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Warning" | globalTranslate }}
            </span>
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
    </div>
    }

    <br />
    <h2 class="section-header">
      {{ "SUBMIT_STATIC_TEXT27" | globalTranslate }}
    </h2>

    <hr />

    @if (!bccExt && !isIME) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT28" | globalTranslate }}
      {{ keyword2 | globalTranslate }}
      {{ "SUBMIT_STATIC_TEXT29" | globalTranslate }}
    </p>
    } @if (bccExt) {
    <p>
      I’m signing this page under penalty of perjury which means I’ve provided
      true answers to all the questions for the person(s) named here and its
      supplements to the best of my knowledge. I also certify that:
    </p>
    } @if (isIME) {
    <p>
      I’m signing this page under penalty of perjury which means I’ve provided
      true answers to all the questions for the person(s) named in this Incurred
      Medical Expense form and its supplements to the best of my knowledge. I
      also certify that:
    </p>
    } @if (!bccExt && !isIME) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT30" | globalTranslate }}
      {{ keyword2 | globalTranslate }}
      {{ "SUBMIT_STATIC_TEXT31" | globalTranslate }}
      {{ keyword2 | globalTranslate }}
      {{ "SUBMIT_STATIC_TEXT32" | globalTranslate }}
    </p>
    } @if (bccExt) {
    <p>
      I agree to submit this form by electronic means. By signing this BCC
      Treatment Plan Extension Request electronically, I understand that an
      electronic signature has the same legal effect and can be enforced in the
      same ways as a written signature.
    </p>
    } @if (isIME) {
    <p>
      I agree to submit this Incurred Medical Expense form by electronic means.
      By signing this Incurred Medical Expense form electronically, I understand
      that an electronic signature has the same legal effect and can be enforced
      in the same ways as a written signature.
    </p>
    } @if (!bccExt && !isIME) {
    <p class="static-text">
      {{ "SUBMIT_STATIC_TEXT33" | globalTranslate }}
      {{ keyword2 | globalTranslate }}.
    </p>
    } @if (bccExt) {
    <p>
      I understand the questions and statements on this BCC Treatment Plan
      Extension Request.
    </p>
    } @if (isIME) {
    <p>
      I understand the questions and statements on this Incurred Medical Expense
      form.
    </p>
    }
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT34" | globalTranslate }}</p>
    <p class="static-text">{{ "SUBMIT_STATIC_TEXT35" | globalTranslate }}</p>

    <!-- Assisting Person Signature:
                MP-AFB,RMB/RMC
                VTC-RMB/RMC
                AHS-AFB,RMB/RMC -->
    @if (( (!isPartner && (isAFB || isRmbRmc)) || (isPartner && isRmbRmc) ||
    isKepro) && authRep && !isFinReassessment) {
    <div>
      <h2 class="section-header">
        {{ "SUBMIT_STATIC_TEXT36" | globalTranslate }}
      </h2>
      <hr />
      @if (!isPreterm) {
      <nh-checkbox
        name="applicationSignedBySw"
        [control]="getControl('data.applicationSignedBySw')"
        checkedValue="ASSISTING_PERSON"
        label="{{ 'SUBMIT_STATIC_TEXT37' | globalTranslate }}"
        class="label-section"
        [mandatory]="true"
      >
      </nh-checkbox>
      } @if (isPreterm) {
      <nh-checkbox
        name="applicationSignedBySw"
        [control]="getControl('data.applicationSignedBySw')"
        checkedValue="ASSISTING_PERSON"
        label="{{ 'SUBMIT_STATIC_TEXT37_QFR' | globalTranslate }}"
        class="label-section"
        [mandatory]="true"
      >
      </nh-checkbox>
      }
      <nh-alert
        type="danger"
        [isOpen]="isShowSign && !this.getValue('data.applicationSignedBySw')"
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Warning" | globalTranslate }}
            </span>
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <nh-field
        id="sub_applicationSignName"
        label="{{ 'SIGNATURE' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          name="applicationSignName"
          formControlName="applicationSignName"
          aria-label="applicationSignName"
          maxlength="93"
        />
      </nh-field>
    </div>
    }

    <!-- Applicant's Signature:
                    MP-AFB,RMB/RMC
                    VTC-RMB/RMC
                    AHS-AFB,RMB/RMC -->
    @if (( (!isPartner && (isAFB || isRmbRmc)) || (isPartner && isRmbRmc) ||
    isKepro) && !authRep && !isFinReassessment) {
    <div>
      <h2 class="section-header">
        {{ "SUBMIT_STATIC_TEXT38" | globalTranslate }}
      </h2>
      <hr />
      @if (!isPreterm) {
      <nh-checkbox
        name="applicationSignedBySw"
        [control]="getControl('data.applicationSignedBySw')"
        checkedValue="HOUSEHOLD_MEMBER"
        [mandatory]="true"
        [globalLangTranslate]="false"
        label="{{ 'SUBMIT_STATIC_TEXT39' | globalTranslate }}"
        class="label-section"
      >
      </nh-checkbox>
      } @if (isPreterm) {
      <nh-checkbox
        name="applicationSignedBySw"
        [control]="getControl('data.applicationSignedBySw')"
        checkedValue="HOUSEHOLD_MEMBER"
        [mandatory]="true"
        tabindex="0"
        [globalLangTranslate]="false"
        label="{{ 'SUBMIT_STATIC_TEXT39_QFR' | globalTranslate }} {{
          keyword4 | globalTranslate
        }}."
        class="label-section"
      >
      </nh-checkbox>
      }
      <nh-alert
        type="danger"
        [isOpen]="isShowSign && !getValue('data.applicationSignedBySw')"
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Warning" | globalTranslate }}
            </span>
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <nh-field
        id="sub_applicationSignName"
        label="{{ 'SIGNATURE' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          name="applicationSignName"
          formControlName="applicationSignName"
          [attr.aria-label]="'SIGNATURE' | globalTranslate"
          maxlength="93"
          aria-required="true"
        />
      </nh-field>
    </div>
    }

    <!-- AHS case notes-->
    @if (isKepro) {
    <div>
      <div class="form-check-label">
        <span class="label-section">{{ "CASE_NOTES" | globalTranslate }}</span>
        {{ applicationSource | globalTranslate }}
        {{ "CASE_NOTES_TEXT" | globalTranslate }} {{ userFullName }}({{
          userName
        }}) {{ "ON" | globalTranslate }}
        {{ convertMonth(appSubmittedDate | date: "longDate") }}.
        <nh-field
          id="sub_callCenterComments"
          label
          [mandatory]="false"
          [attr.aria-required]="false"
        >
          <textarea
            maxlength="2000"
            placeholder="Additional Notes..."
            class="form-control"
            name="callCenterComments"
            formControlName="callCenterComments"
            aria-label="callCenterComments"
            rows="5"
            autofocus="true"
            style="margin-top: 5px"
          ></textarea>
        </nh-field>
      </div>
    </div>
    }

    <!-- PP-Presumptive, FC, VTC-RMB/RMC -->
    @if ((isPresumptive || isPartner) && !isKepro && !isFinReassessment) {
    <div>
      <!-- Assisting Person -->
      @if (!isIME && authRep && (!isRmbRmc)) {
      <h2 class="section-header">
        {{ "SUBMIT_STATIC_TEXT36" | globalTranslate }}
      </h2>
      } @if (!isIME && authRep && (!isRmbRmc)) {
      <hr />
      } @if (!isIME && authRep && (!isRmbRmc)) {
      <nh-checkbox
        name="applicationSignedBySw"
        uniqueString="application"
        [control]="getControl('data.applicationSignedBySw')"
        checkedValue="ASSISTING_PERSON"
        [mandatory]="true"
        label="{{ 'SUBMIT_STATIC_TEXT37' | globalTranslate }}"
        class="label-section"
      >
      </nh-checkbox>
      }
      <!-- Applicant -->
      @if (!isIME && !authRep && (!isRmbRmc)) {
      <h2 class="section-header">
        {{ "SUBMIT_STATIC_TEXT38" | globalTranslate }}
      </h2>
      } @if (!isIME && !authRep && (!isRmbRmc)) {
      <hr />
      } @if (!isIME && !authRep && (!isRmbRmc)) {
      <nh-checkbox
        name="applicationSignedBySw"
        uniqueString="application"
        [control]="getControl('data.applicationSignedBySw')"
        checkedValue="HOUSEHOLD_MEMBER"
        [mandatory]="true"
        label="{{ 'SUBMIT_STATIC_TEXT39' | globalTranslate }}"
        class="label-section"
      >
      </nh-checkbox>
      }
      <nh-alert
        type="danger"
        [isOpen]="
          isShowSign &&
          !getValue('data.applicationSignedBySw') &&
          !isIME &&
          !isRmbRmc
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Warning" | globalTranslate }}
            </span>
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      @if (!isIME && (!isRmbRmc)) {
      <nh-field
        id="sub_applicationSignName"
        label="{{ 'SIGNATURE' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          name="applicationSignName"
          formControlName="applicationSignName"
          aria-label="applicationSignName"
          maxlength="93"
        />
      </nh-field>
      }
      <!-- IME---PP-presumptive, FC, VTC-RMB/RMC Applicant -->
      <!-- Patient or Responsible Party: -->
      @if (isIME) {
      <div>
        <h2 class="section-header">Patient or Responsible Party:</h2>
        <hr />
        <nh-checkbox
          name="applicationSignedBySw"
          uniqueString="application"
          [control]="getControl('data.applicationSignedBySw')"
          checkedValue="PARTNER_PORTAL"
          [mandatory]="true"
          label="By checking this box and typing my name below, I am electronically signing this Incurred Medical Expense form as the patient."
          class="label-section"
        >
        </nh-checkbox>
        <nh-alert
          type="danger"
          [isOpen]="this.isShowSign && !getValue('data.applicationSignedBySw')"
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span class="visually-hidden"
                >{{ "Warning" | globalTranslate }}
              </span>
              <span>{{ "REQUIRED" | globalTranslate }}</span>
            </div>
          </div>
        </nh-alert>
        <nh-field
          id="sub_applicationSignName"
          label="Signature:"
          class="label-section"
        >
          <input
            type="text"
            class="form-control"
            name="applicationSignName"
            formControlName="applicationSignName"
            aria-label="applicationSignName"
            maxlength="93"
          />
        </nh-field>
      </div>
      }
      <!-- TennCare Access Portal User's Signature: -->
      <h2 class="section-header">
        {{ "SUBMIT_STATIC_TEXT40" | globalTranslate }}
      </h2>
      <hr />
      @if (isPresumptive) {
      <div class="static-text">
        By signing, you attest that you have accurately recorded information
        provided by the applicant. By signing, you also agree that you
        understand you must:
        <ul class="list-inline">
          <li>Tell the applicant of the presumptive determination.</li>
          <li>
            Offer to mail a paper Application or to help the applicant apply
            online for ongoing TennCare.
          </li>
          <li>
            Tell the applicant a full Application must be filed by the end of
            next month or that they may lose eligibility.
          </li>
          <li>
            Tell the applicant, if denied, they can still send in a full
            Application or apply again at
            <a class="add-primary-color" href="https://tenncareconnect.tn.gov"
              >https://tenncareconnect.tn.gov</a
            >
            for TennCare and other programs.
          </li>
        </ul>
      </div>
      }
      <br />
      @if (!bccExt && !isIME) {
      <nh-checkbox
        name="partnerSignedBySw"
        [control]="getControl('data.partnerSignedBySw')"
        checkedValue="PARTNER_PORTAL"
        [mandatory]="true"
        label="{{ 'SUBMIT_STATIC_TEXT41' | globalTranslate }}"
        class="label-section"
      >
      </nh-checkbox>
      } @if (bccExt) {
      <nh-checkbox
        name="partnerSignedBySw"
        [control]="getControl('data.partnerSignedBySw')"
        checkedValue="PARTNER_PORTAL"
        [mandatory]="true"
        label="{{ 'SUBMIT_STATIC_TEXT46' | globalTranslate }}"
        class="label-section"
      >
      </nh-checkbox>
      } @if (isIME) {
      <nh-checkbox
        name="partnerSignedBySw"
        [control]="getControl('data.partnerSignedBySw')"
        checkedValue="PARTNER_PORTAL"
        [mandatory]="true"
        label="By checking this box and typing my name below, I am electronically signing this Incurred Medical Expense form as the TennCare Access user."
        class="label-section"
      >
      </nh-checkbox>
      }
      <nh-alert
        type="danger"
        [isOpen]="this.isShowPartner && !getValue('data.partnerSignedBySw')"
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Warning" | globalTranslate }}
            </span>
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <nh-field
        id="sub_partnerSignName"
        label="{{ 'SIGNATURE' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          name="partnerSignName"
          formControlName="partnerSignName"
          aria-label="partnerSignName"
          maxlength="93"
        />
      </nh-field>
    </div>
    }

    <!-- PP-FRM -->
    @if (isFinReassessment && !isKepro) {
    <div>
      <!-- APPLICANT -->
      @if (!authRep) {
      <div>
        <p class="section-header">
          <strong>{{ "SUBMIT_STATIC_TEXT38" | globalTranslate }}</strong>
        </p>
        <hr />
        <nh-checkbox
          name="applicationSignedBySw"
          uniqueString="applicationBy"
          [control]="getControl('data.applicationSignedBySw')"
          checkedValue="HOUSEHOLD_MEMBER"
          [mandatory]="true"
          label="{{ 'SUBMIT_STATIC_TEXT39' | globalTranslate }}"
          class="label-section"
        >
        </nh-checkbox>
      </div>
      }
      <!-- ASSISTING PERSON -->
      @if (authRep) {
      <div>
        <p class="section-header">
          <strong>{{ "SUBMIT_STATIC_TEXT36" | globalTranslate }}</strong>
        </p>
        <hr />
        <nh-checkbox
          name="applicationSignedBySw"
          uniqueString="applicationBy"
          [control]="getControl('data.applicationSignedBySw')"
          checkedValue="ASSISTING_PERSON"
          [mandatory]="true"
          label="{{ 'SUBMIT_STATIC_TEXT37' | globalTranslate }}"
          class="label-section"
        >
        </nh-checkbox>
      </div>
      }
      <nh-alert
        type="danger"
        [isOpen]="isShowSign && !this.getValue('data.applicationSignedBySw')"
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span class="visually-hidden"
              >{{ "Warning" | globalTranslate }}
            </span>
            <span>{{ "SUBMIT_STATIC_TEXT43" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <nh-field
        id="sub_applicationSignName"
        label="{{ 'SIGNATURE' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          name="applicationSignName"
          formControlName="applicationSignName"
          aria-label="applicationSignName"
          maxlength="93"
        />
      </nh-field>
      <!-- TennCare Access User: -->
      <div>
        <p class="section-header"><strong>TennCare Access User:</strong></p>
        <hr />
        <nh-checkbox
          name="applicationSigned"
          uniqueString="applicationSigned"
          [control]="getControl('data.applicationSigned')"
          checkedValue="WORKER_PORTAL"
          [mandatory]="true"
          label="By checking this box and typing my name below, I am electronically signing this Financial Reassessment for Medicaid as the TennCare Access User."
          class="label-section"
        >
        </nh-checkbox>
        <nh-alert
          type="danger"
          [isOpen]="isShowPartner && !this.getValue('data.applicationSigned')"
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span class="visually-hidden"
                >{{ "Warning" | globalTranslate }}
              </span>
              <span>{{ "SUBMIT_STATIC_TEXT43" | globalTranslate }}</span>
            </div>
          </div>
        </nh-alert>
        <nh-field
          id="sub_partnerSignName"
          label="{{ 'SIGNATURE' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            class="form-control"
            name="partnerSignName"
            formControlName="partnerSignName"
            aria-label="partnerSignName"
            maxlength="93"
          />
        </nh-field>
      </div>
    </div>
    }
  </section>
</nh-form>